import { ItemStorage } from '@/services/storage'

export const accessToken = new ItemStorage<string>('leeaAccess')
export const refreshToken = new ItemStorage<string>('leeaRefresh')
export const deviceId = new ItemStorage<string>('leeaDeviceId')
